import { Button, Form, Modal } from 'antd';
import React, { useState } from 'react';
import { ICON } from './icon';
import EditorPrivacy from '../../../../components/Shared/forms/EditorPrivacy';
import { useTranslation } from 'react-i18next';

export default function Disclaimer({ formMain }) {
    const { t } = useTranslation();
    const [form] = Form.useForm();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handelOpen = () => {
        const disclaimerTh = formMain.getFieldValue([
            'customizeForm',
            'disclaimer',
            'disclaimerTh',
        ]);

        const disclaimerEn = formMain.getFieldValue([
            'customizeForm',
            'disclaimer',
            'disclaimerEn',
        ]);

        setTimeout(() => {
            form.setFieldsValue({
                disclaimerTh,
                disclaimerEn: disclaimerEn === '<p>-</p>' ? '' : disclaimerEn,
            });
        }, 100);
        setIsModalOpen(true);
    };

    const onFinish = () => {
        setIsModalOpen(false);
        formMain.setFieldsValue({
            customizeForm: {
                disclaimer: {
                    disclaimerTh: form.getFieldValue('disclaimerTh'),
                    disclaimerEn: form.getFieldValue('disclaimerEn') || '-',
                },
            },
        });
    };

    const handelClose = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <button
                className="z-10 absolute right-4 flex items-center gap-2 text-[#1890FF] font-semibold"
                type="button"
                onClick={handelOpen}
            >
                {ICON.Edit} {t('Edit')}
            </button>
            <Modal
                centered
                width="50%"
                className="_modal"
                title={t('Disclaimer')}
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={false}
            >
                <Form onFinish={onFinish} form={form} layout="vertical">
                    <Form.Item
                        name="disclaimerTh"
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('Thai')}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <EditorPrivacy
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                    <Form.Item
                        name="disclaimerEn"
                        label={
                            <span className="font-semibold mb-2 text-sm">
                                {t('English')}
                            </span>
                        }
                    >
                        <EditorPrivacy
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                    <div className="mt-9 flex justify-center space-x-3">
                        <Button
                            onClick={handelClose}
                            className="min-w-[120px] border-[#7B67FB] text-[#7B67FB]"
                            size="large"
                        >
                            {t('common.Cancel')}
                        </Button>
                        <Button
                            className="min-w-[120px]"
                            size="large"
                            type="primary"
                            htmlType="submit"
                        >
                            {t('common.Confirm')}
                        </Button>
                    </div>
                </Form>
            </Modal>
        </>
    );
}
